import { Controller, UseFormReturn } from 'react-hook-form';

import { Checkbox } from 'components/Checkbox';
import { RHFTextInput } from 'components/input/RHFTextInput';
import { Flex, Grid } from 'components/layout';
import { Typography } from 'components/typography';

import { QuickQuoteInputs } from '../../types';

interface WhatAreYouShippingSectionProps {
  formMethods: UseFormReturn<QuickQuoteInputs, any, QuickQuoteInputs>;
}

export function WhatAreYouShippingSection({
  formMethods,
}: WhatAreYouShippingSectionProps) {
  const { control } = formMethods;

  return (
    <Flex direction='col' gap='lg' className='w-full mx-0'>
      <Typography
        variant='h5'
        className='text-neutral-800 font-semibold whitespace-nowrap'
      >
        What are you shipping?
      </Typography>

      <Grid cols='1' gap='lg' className='w-full mx-0'>
        <div className='mb-1'>
          <Controller
            name='ltl.commodity.hazmat'
            control={control}
            render={({ field }) => (
              <Checkbox
                label='Hazmat'
                labelClassName='leading-none text-neutral-600 peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
                checked={field.value ?? false}
                onCheckedChange={(checked) => field.onChange(checked)}
              />
            )}
          />
        </div>

        <div className='relative'>
          <RHFTextInput
            name='ltl.value.shipValue'
            label='Ship Value'
            inputType='number'
            placeholder='0.00'
            options={{ valueAsNumber: true, min: 0 }}
            required={false}
            inputClassName='pl-7'
          />
          <span className='absolute left-3 top-[30px] text-neutral-500 pointer-events-none'>
            $
          </span>
        </div>
      </Grid>
    </Flex>
  );
}
